declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const CONSENT_KEY = "cookie_consent";

/**
 * Restore consent state from localStorage.
 * The gtag snippet itself is loaded statically from index.html (Consent Mode v2
 * with default=denied), so this function only needs to grant if previously accepted.
 */
export function initAnalytics(): void {
  if (localStorage.getItem(CONSENT_KEY) === "accepted") {
    grantConsent();
  }
}

export function grantConsent(): void {
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: "granted",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

export function revokeConsent(): void {
  if (!window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: "denied",
  });
}

export function trackPageView(path: string): void {
  if (!window.gtag) return;
  window.gtag("event", "page_view", { page_path: path });
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number>,
): void {
  if (!window.gtag) return;
  window.gtag("event", eventName, params);
}
